import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Input, Icon, Button, Radio } from 'antd';
import search from '../../Images/Icons/search.svg';
import TableView from '../../Components/Table';
import LicenceActiveComponent from './Components/LicenceActiveComponent';
import {
  fetchLicenses,
  fetchDevices,
  addOrUpdateDevice,
  deleteDevice,
} from './Administration.saga';
import styles from './Administration.module.css';
import DeviceActiveComponent from './Components/DeviceActiveComponent';
import DevicePopup from './Components/DevicePopup';
import LiveFeed from '../../Components/LiveFeed';
import ConfirmActionPopup from '../../Components/Popup/ConfirmPopup';
import { isEmpty } from '../../Utils/validationUtil';

const { Search } = Input;

const swithOptions = [
  {
    label: 'Devices',
    key: 'devices',
  },
  {
    label: 'Licenses',
    key: 'licenses',
  },
];

const devicesColumnNames = {
  name: {
    title: 'DEVICE NAME',
    key: 'clientName',
    dataIndex: 'clientName',
    width: '60px',
    order: 0,
  },
  role: {
    title: 'IP ADDRESS',
    dataIndex: 'clientIpAddress',
    key: 'clientIpAddress',
    width: '60px',
    order: 1,
  },
  modelStatus: {
    title: 'MAC ADDRESS',
    dataIndex: 'clientMacAddress',
    key: 'clientMacAddress',
    width: '60px',
    order: 2,
  },
  emptyCells: {
    title: '',
    dataIndex: 'emptyCells',
    key: 'emptyCells',
    width: '10px',
    order: 15,
  },
};

const licencesColumnNames = {
  name: {
    title: 'LICENSE',
    key: 'licenseName',
    dataIndex: 'licenseName',
    width: '100px',
    order: 0,
  },
  status: {
    title: 'STATUS',
    dataIndex: 'licenseIsActive',
    key: 'licenseIsActive',
    width: '100px',
    order: 1,
  },
  activatedDate: {
    title: 'ACTIVATED ON',
    dataIndex: 'licenseActivatedDate',
    key: 'licenseActivatedDate',
    width: '100px',
    order: 3,
  },
  expiry: {
    title: 'EXPIRY DATE',
    dataIndex: 'licenseExpiryDate',
    key: 'licenseExpiryDate',
    width: '100px',
    order: 4,
  },
  emptyCells: {
    title: '',
    dataIndex: 'emptyCells',
    key: 'emptyCells',
    width: '10px',
    order: 15,
  },
};

function Administration({
  history,
  fetchDevicesAction,
  addOrUpdateDeviceAction,
  deleteDeviceAction,
  devices,
  licenses,
  showRedundantViews,
  location,
}) {
  const [licensesParams, setLicensesParams] = useState({
    offset: 0,
    size: 7,
    searchValue: '',
    sortBy: '',
    sortDirection: '',
  });
  const [licensesActiveRecord, setLicensesActiveRecord] = useState({});
  const [devicesParams, setDevicesParams] = useState({
    offset: 0,
    size: 7,
    searchValue: '',
    sortBy: '',
    sortDirection: '',
  });
  const [devicesActiveRecord, setDevicesActiveRecord] = useState({});
  const [activeSwitch, setActiveSwitch] = useState('devices');
  const [showDevicePopup, setShowDevicePopup] = useState(false);
  const [showDeviceActionPopup, setShowDeviceActionPopup] = useState(false);
  const [popupLoading, setPopupLoading] = useState(false);
  const [actionType, setActionType] = useState('');
  const [testDevice, setTestDevice] = useState(false);
  const isDevices = activeSwitch === 'devices';
  let formRef = null;

  useEffect(() => {
    if (location?.state?.activeSwitch) {
      setActiveSwitch(location.state.activeSwitch);
    }
  }, []);

  useEffect(() => {
    if (isDevices) {
      fetchDevicesAction({
        params: devicesParams,
        callback: (activeRecord) => {
          setDevicesActiveRecord(activeRecord);
        },
      });
    } else {
      fetchLicenses({
        params: licensesParams,
        callback: (activeRecord) => {
          setLicensesActiveRecord(activeRecord);
        },
      });
    }
  }, [devicesParams, licensesParams]);

  const handleRecordClick = (record) => {
    if (isDevices) {
      setDevicesActiveRecord(record);
    } else {
      setLicensesActiveRecord(record);
    }
  };

  const handlePageChange = (offset, sortBy, sortDirection) => {
    if (isDevices) {
      setDevicesParams((prevParams) => ({
        ...prevParams,
        offset,
        sortBy,
        sortDirection,
      }));
    } else {
      setLicensesParams((prevParams) => ({
        ...prevParams,
        offset,
        sortBy,
        sortDirection,
      }));
    }
  };

  const handleSearch = (event) => {
    const {
      target: { value },
    } = event;
    if (isDevices) {
      setDevicesParams((prevParams) => ({
        ...prevParams,
        searchValue: value,
      }));
    } else {
      setLicensesParams((prevParams) => ({
        ...prevParams,
        searchValue: value,
      }));
    }
  };

  const handleSwitchChange = (event) => {
    const {
      target: { value },
    } = event;
    setActiveSwitch(value);
    history.push('/administration', { activeSwitch: value });
  };
  const handleTestDevice = () => {
    setTestDevice((prevValue) => !prevValue);
  };
  const handleNewDevicePopup = (currentActionType = '') => {
    setShowDevicePopup(true);
    setActionType(currentActionType);
  };
  const handleNewDeviceCancel = () => {
    setShowDevicePopup(false);
  };
  const handleDeleteDevicePopup = () => {
    setShowDeviceActionPopup(true);
  };
  const handleDeleteDeviceCancel = () => {
    setShowDeviceActionPopup(false);
    setPopupLoading(false);
  };
  const saveFormRef = (formRefVal) => {
    formRef = formRefVal;
  };

  const handleUpdateDevice = (activeRecord) => {
    if (!isEmpty(activeRecord)) {
      setDevicesActiveRecord(activeRecord);
    }
    handleNewDeviceCancel();
  };

  const handleAddOrUpdate = () => {
    const { form } = formRef;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      if (actionType) {
        addOrUpdateDeviceAction({
          data: {
            ...values,
            clientUuid: devicesActiveRecord.clientUuid,
          },
          actionType,
          callback: handleUpdateDevice,
        });
      } else {
        addOrUpdateDeviceAction({
          data: values,
          actionType,
          callback: handleUpdateDevice,
        });
      }
    });
    form.resetFields();
  };

  const handleDeleteDevice = () => {
    setPopupLoading(true);
    deleteDeviceAction({
      clientUuid: devicesActiveRecord.clientUuid,
      callback: () => {
        setDevicesActiveRecord(devices?.inputClients[0]);
        handleDeleteDeviceCancel();
      },
    });
  };

  const licensesList = licenses && licenses.list;
  const devicesList = devices && devices.inputClients;
  const licensesTotalRecords = licenses && licenses.totalRecords;
  const devicesTotalRecords = devices && devices.totalRecords;
  const clientHeight =
    document.getElementById('tableContainer') &&
    document.getElementById('tableContainer').clientHeight;

  return (
    <div className={styles.content}>
      {showRedundantViews && (
        <div className={styles.switchContainer}>
          <Radio.Group
            value={activeSwitch}
            onChange={handleSwitchChange}
            buttonStyle="solid"
          >
            {swithOptions.map((option) => {
              return (
                <Radio.Button
                  className={`${
                    option.key === 'devices'
                      ? styles.usersSwitchButton
                      : styles.licenceSwitchButton
                  }`}
                  key={option.key}
                  value={option.key}
                >
                  {option.label}
                </Radio.Button>
              );
            })}
          </Radio.Group>
        </div>
      )}
      <div className={styles.contentWrapper}>
        <div className={styles.tableWrapper} id="tableContainer">
          <div className={styles.optionsContainer}>
            <Search
              prefix={
                <Icon
                  onClick={() => {
                    if (document.getElementById('searchInputId')) {
                      document.getElementById('searchInputId').focus();
                    }
                  }}
                  component={() => (
                    <img
                      alt="Search Icon"
                      src={search}
                      style={{ height: '20px' }}
                    />
                  )}
                />
              }
              placeholder="Search licenses"
              id="searchInputId"
              onChange={handleSearch}
              className={styles.searchInputBox}
            />
            {isDevices && (
              <Button
                onClick={() => {
                  handleNewDevicePopup();
                }}
                icon="plus"
                className={styles.newUserButton}
              >
                Add New Device
              </Button>
            )}
          </div>
          <div className={styles.tableContainer}>
            <TableView
              clientHeight={clientHeight - 220}
              key={activeSwitch}
              currentPage={
                isDevices ? devicesParams.offset : licensesParams.offset
              }
              tableType={isDevices ? 'clientUu' : 'license'}
              columnNames={isDevices ? devicesColumnNames : licencesColumnNames}
              totalRecords={
                isDevices ? devicesTotalRecords : licensesTotalRecords
              }
              data={isDevices ? devicesList : licensesList}
              fetchRecords={handlePageChange}
              activeRecord={
                isDevices ? devicesActiveRecord : licensesActiveRecord
              }
              onRecordClick={handleRecordClick}
              classNames={{
                tableStyles: styles.administationTable,
              }}
            />
          </div>
        </div>
        <div
          style={{
            marginLeft: licensesList && licensesList.length ? '-10px' : '0px',
          }}
          className={styles.activeItemWrapper}
        >
          {isDevices ? (
            <DeviceActiveComponent
              activeRecord={devicesActiveRecord}
              testDevice={handleTestDevice}
              updateDevice={() => handleNewDevicePopup('update')}
              deleteDevice={handleDeleteDevicePopup}
            />
          ) : (
            <LicenceActiveComponent activeRecord={licensesActiveRecord} />
          )}
        </div>
      </div>
      {showDevicePopup && (
        <DevicePopup
          visible={showDevicePopup}
          onCancel={handleNewDeviceCancel}
          wrappedComponentRef={saveFormRef}
          actionType={actionType}
          onCreate={handleAddOrUpdate}
          activeRecord={isDevices ? devicesActiveRecord : licensesActiveRecord}
        />
      )}
      {showDeviceActionPopup && (
        <ConfirmActionPopup
          title="Delete Device"
          visible={showDeviceActionPopup}
          actionType="stop inference for"
          content="model"
          onCancel={handleDeleteDeviceCancel}
          onConfirm={handleDeleteDevice}
          loading={popupLoading}
          loadingText="Stopping Inference"
        />
      )}
      {testDevice && <LiveFeed />}
    </div>
  );
}

Administration.defaultProps = {
  history: {
    push: (f) => f,
  },
  location: {
    state: {
      activeSwitch: '',
    },
  },
  fetchDevicesAction: (f) => f,
  addOrUpdateDeviceAction: (f) => f,
  deleteDeviceAction: (f) => f,
  devices: {},
  licenses: {},
  showRedundantViews: false,
};

Administration.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  location: PropTypes.shape({
    state: PropTypes.shape({
      activeSwitch: PropTypes.string,
    }),
  }),
  fetchDevicesAction: PropTypes.func,
  addOrUpdateDeviceAction: PropTypes.func,
  deleteDeviceAction: PropTypes.func,
  devices: PropTypes.instanceOf(Object),
  licenses: PropTypes.instanceOf(Object),
  showRedundantViews: PropTypes.bool,
};

export default withRouter(
  connect(
    (state) => ({
      licenses:
        state.administrationReducer && state.administrationReducer.licenses,
      devices:
        state.administrationReducer && state.administrationReducer.devices,
      showRedundantViews: state.commonReducer.showRedundantViews,
    }),
    {
      fetchLicensesAction: fetchLicenses,
      fetchDevicesAction: fetchDevices,
      addOrUpdateDeviceAction: addOrUpdateDevice,
      deleteDeviceAction: deleteDevice,
    }
  )(Administration)
);
